<template>
    <svg class="h-5 w-5" :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" fill="currentColor" aria-hidden="true">
		<path d="M19.47,7.45c-0.27-0.2-0.6-0.28-0.93-0.23c-0.33,0.05-0.62,0.23-0.82,0.49l-5.92,8.04l-3.77-3.01c-0.54-0.41-1.31-0.32-1.74,0.21c-0.43,0.53-0.35,1.31,0.17,1.74l4.78,3.83c0.27,0.21,0.61,0.3,0.94,0.26c0.34-0.04,0.64-0.22,0.84-0.49l6.7-9.09c0.2-0.27,0.28-0.6,0.23-0.93C19.92,7.94,19.74,7.65,19.47,7.45z"/>
        <path d="M13,1C6.37,1,1,6.37,1,13c0,6.63,5.37,12,12,12s12-5.37,12-12C24.99,6.38,19.62,1.01,13,1z M13,23C7.48,23,3,18.52,3,13C3,7.48,7.48,3,13,3s10,4.48,10,10C22.99,18.52,18.52,22.99,13,23z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>